/**
 * Branchen-Dropdown-Optionen für den Mandanten-Stammdaten-Step.
 *
 * Quelle: orientiert sich an den Kategorien aus
 * `@tragfaehigkeit/core/statement/branchHourlyFloor`, ist aber bewusst
 * GETRENNT formuliert — die Synonym-Liste dort ist für die Heuristik (Substring-
 * Match auf Free-Text-Eingabe) gedacht und enthält teils technische Begriffe
 * wie "edv". Die hier verwendeten Labels sind die Mandant-/Berater-sicht.
 *
 * Werte werden 1:1 in `cases.business_branch` (Free-Text) gespeichert. Die
 * Heuristik im Core matcht diese Strings dann zurück auf eine `BranchCategory`,
 * deshalb sind die Werte so gewählt, dass mindestens eines der Synonyme in
 * branchHourlyFloor.ts darin enthalten ist (z.B. "Handwerk" matcht "handwerk").
 *
 * "OTHER" ist ein Sentinel — bei Auswahl rendert der Step ein zusätzliches
 * Free-Text-Feld, dessen Inhalt in `business_branch` landet.
 */

export interface BranchOption {
  /** Wert, der ins Dropdown geschrieben wird. */
  readonly value: string;
  /** UI-Label. */
  readonly label: string;
}

/**
 * Sentinel für „Andere — eigene Eingabe". Im Dropdown sichtbar; bei Auswahl
 * wird statt diesem Wert das Free-Text-Feld committet.
 */
export const BRANCH_OTHER_VALUE = '__other__' as const;

export const BRANCH_OPTIONS: ReadonlyArray<BranchOption> = [
  { value: 'Beratung', label: 'Beratung / Consulting' },
  { value: 'Coaching', label: 'Coaching / Training' },
  { value: 'IT / Softwareentwicklung', label: 'IT / Softwareentwicklung' },
  { value: 'Design / Kreativ', label: 'Design / Kreativ / Medien' },
  { value: 'Handwerk', label: 'Handwerk / Bauhandwerk' },
  { value: 'Pflege / Soziales', label: 'Pflege / Soziales / Betreuung' },
  { value: 'Haushaltsnahe Dienstleistung', label: 'Haushaltsnahe Dienstleistung / Reinigung' },
  { value: 'Einzelhandel', label: 'Einzelhandel / Verkauf' },
  { value: 'Gastronomie', label: 'Gastronomie' },
];

/**
 * Liefert true, wenn der gegebene Wert eines der vorgegebenen Optionen ist.
 * Wird im Step verwendet, um zu entscheiden, ob das „andere"-Free-Text-Feld
 * sichtbar sein soll.
 */
export function isPredefinedBranch(v: string | null | undefined): boolean {
  if (v === null || v === undefined || v.length === 0) return false;
  return BRANCH_OPTIONS.some((o) => o.value === v);
}
